// extracted by mini-css-extract-plugin
export default {"availabilityForADay":"_1jcf2SyF48DconCRdEJGki","availabilityCalendar":"_20bE9aPGPDGfyyeXFVHvHC"};